export var dataHooks = {
  contextMenuButton: 'context-menu-button',
  contextMenuAction: 'context-menu-action',
  menuAction: 'menu-action'
};